export const selectIsLoggedIn = state => state.auth.isLoggedIn;

export const selectUser = state => state.auth.user;

export const selectIsRefreshing = state => state.auth.isRefreshing;

export const selectError = state => state.auth.error;

export const selectCurrentTheme = state => state.auth.currentTheme;

export const selectIsFirstLogin = state => state.auth.isFirstLogin;

export const selectUserType = state => state.auth.userType;

export const selectToken = state => state.auth.token;

export const selectResponse = state => state.auth.response;
